<template>
  <div
    class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3 bg-white p-3 rounded shadow-sm"
  >
    <div class="text-muted small">
      Showing
      <strong>
        {{ (pagination.current_page - 1) * pagination.per_page + 1 }}–{{
          Math.min(
            pagination.current_page * pagination.per_page,
            pagination.total
          )
        }}
      </strong>
      of <strong>{{ pagination.total }}</strong>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button
        class="btn btn-sm btn-outline-secondary"
        :disabled="pagination.current_page === 1"
        @click="emitPage(pagination.current_page - 1)"
      >
        Prev
      </button>

      <input
        type="number"
        min="1"
        :max="pagination.last_page"
        v-model.number="inputPage"
        @keydown.enter="emitPage(inputPage)"
        class="form-control form-control-sm"
        style="width: 80px"
      />

      <span class="text-muted small">/ {{ pagination.last_page }}</span>

      <button
        class="btn btn-sm btn-outline-secondary"
        :disabled="pagination.current_page === pagination.last_page"
        @click="emitPage(pagination.current_page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inputPage: this.pagination.current_page,
    };
  },
  watch: {
    "pagination.current_page"(val) {
      this.inputPage = val;
    },
  },
  methods: {
    emitPage(page) {
      const pageNumber = Number(page);
      if (
        Number.isInteger(pageNumber) &&
        pageNumber >= 1 &&
        pageNumber <= this.pagination.last_page &&
        pageNumber !== this.pagination.current_page
      ) {
        this.$emit("change", Number(pageNumber));
      }
    },
  },
};
</script>
